export const GET_AUTH = 'GET_AUTH';
export const ADD_AUTH = 'ADD_AUTH';
export const REMOVE_AUTH = 'REMOVE_AUTH';

export const GET_PROFILE = 'GET_PROFILE';
export const SET_PROFILE = 'SET_PROFILE';

export const FETCH_BOOKMARK = 'FETCH_BOOKMARK';
export const FETCH_NOTE = 'FETCH_NOTE';
